import React, { useState, useEffect } from 'react';
import Modal from './Modal';
import Progress from './Progress';
import StepX from './StepX';
import StepTasks from './StepTasks';
import StepComment from './StepComment';
import StepWallet from './StepWallet';
import StepSubmit from './StepSubmit';
import whitelistEvent from './event';

export default function MultiStepForm() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [step, setStep] = useState(1);
  const [form, setForm] = useState({
    x: "",
    proofOfComment: "",
    walletEth: ""
  });
  const [timestamp] = useState(Date.now());
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    const unsubscribe = whitelistEvent.subscribe(() => {
      // Don't reset if already successfully submitted
      if (!submitted) {
        setIsModalOpen(true);
        setStep(1);
        setForm({ x: "", proofOfComment: "", walletEth: "" });
      } else {
        setIsModalOpen(true);
      }
    });

    return () => unsubscribe?.();
  }, [submitted]);

  const closeModal = () => {
    // Prevent closing if successfully submitted (stay on last step)
    if (submitted) return;
    setIsModalOpen(false);
  };

  const next = () => setStep(step + 1);
  const prev = () => setStep(step - 1);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  return (
    <>
      <Modal isOpen={isModalOpen} onClose={closeModal} lockClose={submitted}>
        <Progress step={step} totalSteps={5} />

        {step === 1 && (
          <StepX form={form} handleChange={handleChange} next={next} />
        )}

        {step === 2 && (
          <StepTasks form={form} next={next} prev={prev} />
        )}

        {step === 3 && (
          <StepComment form={form} handleChange={handleChange} next={next} prev={prev} />
        )}

        {step === 4 && (
          <StepWallet form={form} handleChange={handleChange} next={next} prev={prev} />
        )}

        {step === 5 && (
          <StepSubmit
            form={form}
            timestamp={timestamp}
            onSuccess={() => setSubmitted(true)}
          />
        )}
      </Modal>
    </>
  );
}
